import React from 'react'
import fotoFrente from '../../assets/img/site/rango-fotoFrente.jpg';

const Historia = () => {
	return (
		<section className="dark">
			<div className="row mx-0">
				<div className="col-12 col-lg-6">
					<div className="px-5 py-10">
						<h2 className="big dark-title"><span>UN POCO DE</span>NUESTRA HISTORIA</h2>
						<p className="my-4">
							RANGO COMERCIAL nació como un comercio en el año 1980, como una unipersonal que comercializaba principalmente revestimientos.<br />
						A medida que fue pasando el tiempo, fuimos incorporando productos y ampliando nuestra oferta. Hoy contamos con cinco sucursales.<br />
						Cuatro ubicadas en el sur de la provincia de Buenos Aires, Médanos, Hilario Ascasubi, Villalonga y Algarrobo. Otra en provincia de Río Negro,
						en la ciudad de Río Colorado. Nuestro centro de distribución se encuentra en La Adela al sur de provincia de La Pampa.<br />
						Actualmente comercializamos todo lo que se refiere a la construcción, también incorporamos artículos para el hogar, electrodomésticos,
						ferretería, pinturería, artículos rurales, muebles y mucho más.<br />
						La política de la empresa es seguir creciendo, es por esto que los proyectos no dejan de aparecer y son siempre bienvenidos.
						Esta es una breve reseña de nuestra pequeña pero dinámica empresa.
							</p>
					</div>
				</div>

				<div className="col-12 col-lg-6 p-0">
					<div className="img-box right">
						<img className="img-fluid" src={fotoFrente} alt="Frente Rango Comercial" />
					</div>
				</div>
			</div>
		</section>
	);
}

export default Historia;
